import { SET_SINGLE_COMPANY_DETAILS } from "constants/riskAdmin/riskAdminConst";

const initial_state = {
  listings: {},
  singleCompanyDetails: [],
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case SET_SINGLE_COMPANY_DETAILS:
      return {
        ...state,
        singleCompanyDetails: action.payload,
      };

    case "SET_LISTING_STATE": {
      const { key, data } = action.payload;
      return {
        ...state,
        listings: {
          ...state.listings,
          [key]: {
            ...(state.listings[key] || {}),
            ...data,
          },
        },
      };
    }

    default:
      return state;
  }
}
